import React, { memo } from 'react'

import { func, oneOf } from 'prop-types'

import Modal from 'Pods/Shared/Modal/Modal'

import AuthStep from './Components/AuthStep/AuthStep'
import CodeStep from './Components/CodeStep/CodeStep'
import ModelGallery from './Components/ModelGallery/ModelGallery'
import PasswordStep from './Components/PasswordStep/PasswordStep'
import SuccessStep from './Components/SuccessStep/SuccessStep'
import { MODE, STEP } from './constants'
import useAiSignIn from './Hooks/useAiSignIn'

function AiSignInModal({
  mode: initialMode = MODE.SIGNUP, initialStep = STEP.AUTH, onClose: handleClose,
}) {
  const {
    mode,
    step,
    email,
    optIn,
    digits,
    hasCodeError,
    password,
    passwordError,
    showPasswordRequiredNotice,
    isPasswordSubmitting,
    isTwoFaRequired,
    twoFaCode,
    captchaEnabled,
    resendSecondsLeft,
    ariaLabel,
    setOptIn,
    handleEmailChange,
    requestCode,
    handleSwitchMode,
    handleDigitsChange,
    handleResend,
    handlePasswordChange,
    handleTwoFaCodeChange,
    handleSwitchToPassword,
    handleBackFromPassword,
    handlePasswordLogin,
    handleSocial,
  } = useAiSignIn({ initialMode, initialStep })

  return (
    <Modal
      isOpen
      width="large"
      customClass="ai-sign-in-modal"
      ariaLabel={ariaLabel}
      onClose={handleClose}
    >
      <div className="ai-sign-in-modal__body">
        <div className="ai-sign-in-modal__main">
          {step === STEP.AUTH && (
            <AuthStep
              mode={mode}
              email={email}
              optIn={optIn}
              onEmailChange={handleEmailChange}
              onOptInChange={setOptIn}
              onSubmit={requestCode}
              onSocial={handleSocial}
              onSwitchMode={handleSwitchMode}
              onSwitchToPassword={handleSwitchToPassword}
            />
          )}
          {step === STEP.CODE && (
            <CodeStep
              email={email}
              digits={digits}
              hasError={hasCodeError}
              resendSecondsLeft={resendSecondsLeft}
              onDigitsChange={handleDigitsChange}
              onResend={handleResend}
            />
          )}
          {step === STEP.PASSWORD && (
            <PasswordStep
              email={email}
              password={password}
              passwordError={passwordError}
              showRequiredNotice={showPasswordRequiredNotice}
              isSubmitting={isPasswordSubmitting}
              isTwoFaRequired={isTwoFaRequired}
              twoFaCode={twoFaCode}
              captchaEnabled={captchaEnabled}
              onEmailChange={handleEmailChange}
              onPasswordChange={handlePasswordChange}
              onTwoFaCodeChange={handleTwoFaCodeChange}
              onSubmit={handlePasswordLogin}
              onBack={handleBackFromPassword}
            />
          )}
          {step === STEP.SUCCESS && <SuccessStep mode={mode} />}
        </div>

        <ModelGallery />
      </div>
    </Modal>
  )
}

AiSignInModal.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]),
  initialStep: oneOf([STEP.AUTH, STEP.CODE, STEP.PASSWORD, STEP.SUCCESS]),
  onClose: func.isRequired,
}

export default memo(AiSignInModal)
